import { IconEye, IconEyeOff, IconLock, IconUser } from "@tabler/icons-react";
import styles from "../../../styles/MobileNumberLogin.module.css";

// images
import LoginMobileNumberImg from "../../../assets/images/login-mobile-number-img.png";
import LegionLogo from "../../../assets/images/legion-logo.png";

// legion
import { Flex, Button, Text, Anchor, Textfield, Image, Checkbox } from "@legion-ui/core";

// hooks
import { useTelkomIdLogin } from "../../../hooks/useTelkomIdLogin";
import { useState } from "react";

export const TelkomIdLogin = () => {
  const { state, handleForms, handleLogin } = useTelkomIdLogin();
  const [passwordStatus, setPasswordStatus] = useState("password");

  const togglePassword = () =>{
    if (passwordStatus === "password") {
      setPasswordStatus("text")
      return;
    }

    setPasswordStatus("password")
  }

  return (
    <Flex width="100%" height="100%">
      <Flex
        alignY="center"
        alignX="center"
        padding={["5rem 0", "26px 16px"]}
        width={["", "50%"]}
        className={styles.login__form}
      >
        <Flex
          direction="column"
          style={{ maxWidth: "464px", height: "min-content" }}
          mq={{
            padding: {
              md: "2rem 1rem",
            },
          }}
        >
          <Anchor href="/" block>
            <Image
              width="146px"
              margin="0 0 32px 0"
              src={LegionLogo}
              alt="legion logo"
            />
          </Anchor>
          <Text
            as="h3"
            size={["36px", "24px"]}
            weight="700"
            margin="0 0 12px 0"
            color="tertiary900"
          >
            Sign In
          </Text>
          <Text
            as="p"
            size={["16px", "14px"]}
            weight="400"
            margin="0 0 24px 0"
            color="tertiary500"
          >
            Welcome back! Sign in to access your account with your registered
            Telkom ID
          </Text>

          <Textfield
            iconLeft={<IconUser size={28} />}
            label="NIK"
            placeholder="NIK"
            type="number"
            status={state.nikStatus}
            message={state.nikErrorMessage}
            onChange={handleForms("nik")}
            padding="1rem 0"
          />

          <Textfield
            iconLeft={<IconLock size={28} />}
            iconRight={
              passwordStatus === "password" ? 
                  <IconEyeOff className={styles.btn__password} onClick={togglePassword} size="28" /> : 
                  <IconEye className={styles.btn__password} onClick={togglePassword} size="28" />
            }
            label="Password"
            placeholder="Type your password"
            type={passwordStatus}
            status={state.passwordStatus}
            message={state.passwordErrorMessage}
            onChange={handleForms("password")}
          />

          <Flex padding='1.25rem 0' alignX='space-between'>
            <Checkbox label="Remember me" classify="sm" />
          </Flex>

          <Button margin="0 0 1rem 0" center onClick={handleLogin}>
            Login
          </Button>

          <div style={{ textAlign: "center" }}>
            <Text as="p" color="tertiary500">
              &#9432; Forgot your NIK?
            </Text>
            <Anchor
              href="/contact-us/nik"
              weight="700"
              color="primary500"
            >
              Contact Us
            </Anchor>
          </div>
        </Flex>
      </Flex>

      <Flex alignX="end" className={styles.login__image} width={["", "50%"]}>
        <Image
          width="auto"
          height="100%"
          src={LoginMobileNumberImg}
          fit="cover"
          alt="login mobile number as primary key image"
        />
      </Flex>
    </Flex>
  );
};
